// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_service_location".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "organization_service_location" table (1:1 with a DB row, on the wire). */
export const organizationServiceLocationAtomSchema = z.object({
    id: z.string(),
    serviceId: z.string(),
    locationId: z.string(),
    priceCentsOverride: z.number().nullable(),
    durationMinutesOverride: z.number().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationServiceLocation.js.map